module.exports = __webpack_public_path__ + "static/media/oberflex-hetreetuve-1200x2490.98641bf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-hetreetuve-1200x2490.jpg
// module id = 1028
// module chunks = 37